export default __webpack_public_path__ + "static/media/logo.aeffe6a7.svg";